import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <PageHero
        eyebrow="Blog"
        title="Notes on water,"
        italic="one post at a time."
        description="Weekly, plain-English writing about the water in Northern Utah and Southern Idaho — what's actually in it, how to test it, and what really works to fix it."
        testId="blog-hero"
      />

      <section className="py-32 lg:py-40 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px]">
          <div className="grid grid-cols-12 gap-y-16 lg:gap-x-16 items-center">
            <Reveal className="col-span-12 lg:col-span-7" testId="blog-coming-soon">
              <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--blue)] mb-6">
                Coming soon
              </div>
              <h2 className="font-display font-semibold text-[clamp(2rem,5vw,4.5rem)] leading-[1.02] text-white">
                First posts land<br />
                <span className="font-editorial italic font-normal text-[color:var(--blue)]">
                  very soon.
                </span>
              </h2>
              <p className="mt-8 text-[15.5px] leading-[1.8] text-[color:var(--muted)] font-body max-w-xl">
                In the meantime, the fastest way to understand your water is still the oldest one: put it in a jar and let Vanguard Water Systems test it. Free, in-home, no obligation.
              </p>
              <div className="mt-10 flex flex-wrap gap-3">
                <Link to="/contact" className="btn-primary" data-testid="blog-cta-quote">
                  Book a Free Water Test <ArrowUpRight className="h-4 w-4" />
                </Link>
                <a
                  href="mailto:VanguardWaterSystems@gmail.com?subject=Notify%20me%20when%20the%20Vanguard%20blog%20launches"
                  className="btn-ghost"
                  data-testid="blog-cta-notify"
                >
                  <Mail className="h-4 w-4" /> Email me when it launches
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.15} className="col-span-12 lg:col-span-5" y={40} testId="blog-topics">
              <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--muted)] mb-6">
                Topics we'll cover
              </div>
              <ul className="space-y-6">
                {[
                  "Hard water in Cache Valley — what the numbers actually mean",
                  "Softener vs. conditioner — the honest difference",
                  "Reverse osmosis: worth it, or overkill?",
                  "Well water in Southern Idaho: iron, sulfur, arsenic",
                  "PFAS at the tap — testing and treatment options",
                  "Buying a home? What every water report should include",
                ].map((t, i) => (
                  <li
                    key={t}
                    className="flex items-start gap-4 pt-6 border-t border-[color:var(--border)]"
                  >
                    <div className="font-display text-[color:var(--blue)] font-semibold tabular text-lg shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="text-[15px] leading-[1.7] text-white/90 font-body">{t}</div>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
